import { ColDef } from 'ag-grid-community';

export const TerritorySearchColumnDefs = (): ColDef[] => [
  {
    valueFormatter: ({ data }) => {
      const { territoryId, territoryName, primarySeller } = data;
      const first = primarySeller?.firstName ?? '';
      const last = primarySeller?.lastName ?? '';
      return primarySeller
        ? `${territoryId} / ${territoryName} / ${first} ${last}`
        : `${territoryId} / ${territoryName}`;
    }
  }
];
